import BuildWrapper from "../views/build/user/App.vue";
import BuildEdit from "../views/build/user/Edit.vue";
import BuildEditBatch from "../views/build/user/EditBatch.vue";
import BuildImportFile from "../views/build/user/ImportFile.vue";
import BuildList from "../views/build/user/List.vue";
import { fromBase64 } from "@/lib/stringUtil";

export const userRoute = () => {
  return {
    component: BuildWrapper,
    meta: { title: "User", breadcrumb: "User" },
    name: "userBuild",
    path: "user",
    redirect: { name: "userList" },
    children: [
      {
        component: BuildEdit,
        meta: {
          title: "Create User | Users",
          breadcrumb: "Create",
        },
        name: "userCreate",
        path: "create",
        props: { entityName: "user" },
      },
      {
        component: BuildEdit,
        meta: {
          title: "Edit User | Users",
          breadcrumb: "Edit",
        },
        name: "userEdit",
        path: "edit/:id",
        props: route => {
          let {
            params: { id },
          } = route;

          return { entityName: "user", id };
        },
      },
      {
        component: BuildEditBatch,
        meta: {
          title: "Batch Edit User | Users",
          breadcrumb: "Edit (Users)",
        },
        name: "userEditBatch",
        path: "edit-batch/:idListEncoded",
        props: route => {
          const {
            params: { idListEncoded },
          } = route;

          const idListString = fromBase64(idListEncoded);
          const idList = idListString.split(",");

          return { entityName: "user", idList };
        },
      },
      {
        component: BuildList,
        name: "userList",
        meta: {
          breadcrumb: "List",
          title: "User List | Users",
        },
        path: "list",
        props: route => {
          const {
            query: { filterMode },
          } = route;

          return { entityName: "user", filterMode: parseInt(filterMode, 10) };
        },
      },
      {
        component: BuildImportFile,
        meta: {
          title: "Upload Instructions | Users",
          breadcrumb: "Import",
        },
        name: "userImportFile",
        path: "import-file",
        props: {
          entityName: "user",
        },
      },
      {
        component: BuildImportFile,
        meta: {
          title: "Import Confirm | Users",
          breadcrumb: "Import Confirm",
        },
        name: "userImportFileConfirm",
        path: "import-file/:fileId",
        props: route => {
          let {
            params: { fileId },
          } = route;

          fileId = parseInt(fileId, 10);

          return { entityName: "user", fileId };
        },
      },
    ],
  };
};
